/**
 * Code by Ruby - Convx - TL-3727
 * Gift Card Recipient Custom Element
 * Handles the gift card recipient feature for Shopify gift cards
 */
class GiftCardRecipient extends HTMLElement {
  constructor() {
    super();
    this.recipientCheckbox = null;
    this.recipientOtherProperties = [];
    this.recipientSendOnProperty = null;
    this.offsetProperty = null;
    this.recipientFieldsContainer = null;
  }

  connectedCallback() {
    const properties = Array.from(this.querySelectorAll('[name*="properties"]'));
    const checkboxPropertyName = "properties[__shopify_send_gift_card_to_recipient]";
    
    this.recipientCheckbox = properties.find(input => input.name === checkboxPropertyName);
    
    // Get all other property inputs (email, name, date, message)
    this.recipientOtherProperties = properties.filter(input => input.name !== checkboxPropertyName);
    
    // Get the container that holds the recipient fields
    this.recipientFieldsContainer = this.querySelector(".gift-card-recipient__fields");
    
    // Get the timezone offset property (hidden input)
    this.offsetProperty = this.querySelector('[name="properties[__shopify_offset]"]');
    if (this.offsetProperty) {
      // Set timezone offset for proper date handling
      this.offsetProperty.value = new Date().getTimezoneOffset().toString();
    }
    
    // Get the "Send on" date input
    this.recipientSendOnProperty = this.querySelector('[name="properties[Send on]"]');
    
    // Set min and max dates for the date picker (today to 90 days from now)
    if (this.recipientSendOnProperty) {
      const minDate = new Date();
      const maxDate = new Date();
      maxDate.setDate(minDate.getDate() + 90);
      
      this.recipientSendOnProperty.setAttribute("min", this.formatDate(minDate));
      this.recipientSendOnProperty.setAttribute("max", this.formatDate(maxDate));
    }
    
    // Listen for checkbox changes
    if (this.recipientCheckbox) {
      this.recipientCheckbox.addEventListener("change", () => this.synchronizeProperties());
    }
    
    // Initialize the state
    this.synchronizeProperties();
    
    // Add character counter for message field
    this.setupMessageCounter();
  }

  synchronizeProperties() {
    // Enable/disable recipient fields based on checkbox state
    const isChecked = this.recipientCheckbox?.checked || false;
    
    this.recipientOtherProperties.forEach(property => {
      property.disabled = !isChecked;
      if (isChecked && property.type === 'email') {
        property.required = true;
      } else if (!isChecked) {
        property.required = false;
      }
    });
    
    // Show/hide the fields container
    if (this.recipientFieldsContainer) {
      this.recipientFieldsContainer.toggleAttribute("hidden", !isChecked);
    }
  }

  formatDate(date) {
    // Format date as YYYY-MM-DD for date input
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - offset * 60 * 1000);
    return offsetDate.toISOString().split("T")[0];
  }

  setupMessageCounter() {
    const messageField = this.querySelector('[name="properties[Message]"]');
    const counter = this.querySelector('.gift-card-recipient__character-count') || this.querySelector('.character-count');
    
    if (messageField && counter) {
      const updateCounter = () => {
        const length = messageField.value.length;
        const maxLength = messageField.getAttribute('maxlength') || 200;
        counter.textContent = `${length} / ${maxLength}`;
      };
      
      messageField.addEventListener('input', updateCounter);
      updateCounter();
    }
  }
}

if (!window.customElements.get("gift-card-recipient")) {
  window.customElements.define("gift-card-recipient", GiftCardRecipient);
}